import { getAge } from './validateAge'

function validateStep1(values) {
  let errorsStep1 = {}
  let documentNumber = values && values.documentNumber ? values.documentNumber : ''

  const validEmail = /^([\w-\.]+@([\w-]+\.)+(com|com.co|es|co))?$/

  if (!values.email) {
    errorsStep1.email = 'Ingresa un email válido'
  } else if (
    !/^([a-z]){1,}([a-z0-9._-]){1,}([@]){1}([a-z]){2,}([.]){1}([a-z]){2,}([.]?){1}([a-z]?){2,}$/i.test(
      values.email
    )
  ) {
    errorsStep1.email = 'Debes elegir un email válido'
  } else if (!validEmail.test(values.email)) {
    errorsStep1.email = 'Debes elegir un email válido'
  }

  if (!values.date) {
    errorsStep1.date = 'Debes ser mayor de edad'
  } else if (getAge(values.date) < 18) {
    errorsStep1.date = 'Debes ser mayor de edad'
  }

  if (!values.name) {
    errorsStep1.name = 'Nombre requerido'
  } else if (/[-!$%^&*()_+|~=`\\#{}\[\]:";'<>?,.\/]/.test(values.name)) {
    errorsStep1.name = 'Nombre requerido'
  } else if (/\d/.test(values.name)) {
    errorsStep1.name = 'Nombre inválido'
  }

  if (!values.apelido) {
    errorsStep1.apelido = 'Apellido requerido'
  } else if (/[-!$%^&*()_+|~=`\\#{}\[\]:";'<>?,.\/]/.test(values.apelido)) {
    errorsStep1.apelido = 'Apellido requerido'
  } else if (/\d/.test(values.apelido)) {
    errorsStep1.apelido = 'Apellido inválido'
  }

  if (!values.documentType) {
    errorsStep1.documentType = 'Debes elegir un tipo de documento'
  }

  if (!values.documentNumber || !values.documentType) {
    errorsStep1.documentNumber = 'Ingresa un número de documento válido'
  } else if (
    values.documentType === '1' &&
    (documentNumber.length < 6 || documentNumber.length > 10)
  ) {
    errorsStep1.documentNumber = 'Ingresa un número de cédula de ciudadanía válido'
  } else if (
    values.documentType === '2' &&
    (documentNumber.length < 6 || documentNumber.length > 7)
  ) {
    errorsStep1.documentNumber = 'Ingresa un número de cédula de extranjería válido'
  } else if (/[-!$%^&*()_+|~=`\\#{}\[\]:";'<>?,.\/]/.test(values.documentNumber)) {
    errorsStep1.documentNumber = 'Ingresa un número de documento válido'
  } else if (values.documentNumber === values.celular) {
    errorsStep1.documentNumber = 'Ingresa un número de documento válido'
  }

  return errorsStep1
}

function validate(values) {
  let errors = {}
  let celular = values && values.celular ? values.celular : ''

  let _direccion = values && values.direccion ? values.direccion : ''
  let _complemento = values && values.complemento ? values.complemento : ''
  let _localNumber = values && values.localNumber ? values.localNumber : ''

  if (!values.ciudad || values.ciudad < 1) {
    errors.ciudad = 'Debes escoger una ciudad válida'
  }
  if (!values.direccion || _direccion.length < 1) {
    errors.direccion = 'Este campo es requerido'
  }
  if (!values.complemento || _complemento.length < 1) {
    errors.complemento = 'Este campo es requerido'
  }
  if (!values.celular || celular.length < 10) {
    errors.celular = 'Ingresa un número de celular válido'
  } else if (values.celular === values.documentNumber) {
    errors.celular = 'Ingresa un número de celular válido'
  }

  if (!values.localNumber && _localNumber.length < 1) {
    errors.localNumber = 'Este campo es requerido'
  }
  // if (!values.localType && values.localType < 1) {
  //   errors.localType = 'Este campo es requerido';
  // }
  // if (!values.acceptTerm) {
  //   errors.acceptTerm = 'Debes aceptar los términos y condiciones';
  // }
  // if (!values.idReferencia) {
  //   errors.idReferencia = 'Este campo es requerido';
  // }
  return errors
}

export { validate, validateStep1 }
